<template>
    <div class="page page-scene">
        <audio ref="bgMusic" src="https://static.web.sdo.com/xuezu/pic/20220524_City/bg.mp3" preload="auto"
            loop="loop"></audio>
        <div v-if="!userinfo.phone" class="user-info user-info1">
            <strong>您尚未登录</strong>
            <span class="login" @click="loginShow">立即登录</span>
        </div>
        <div v-else class="user-info user-info2">
            <strong>{{ userinfo.phone }}</strong>
            <span class="logout" @click="loginShow"></span>
            <span class="bind" @click="bindsShow">绑定角色</span>
        </div>
        <ul class="top-btns-wrapper">
            <li @click="goMyBag"></li>
            <li @click="showPop('ruleshow')"></li>
            <li>
                <a @click='CsLib.buttonCounts("下载")' href="https://blood.web.sdo.com/download/index.html"></a>
            </li>
            <li :class='isplaying ? "" : "off"' @click="musicEvent"></li>
        </ul>
        <div class="bag-wrapper">
            福袋<strong>{{ currentbag || 0 }}</strong>
            <div :class='classname' @click="getBag"></div>
        </div>
        <div class="speaker-wrapper">
            <!-- 滚动喇叭 -->
            <Speaks :list="louders" />
            <div class="more" @click="speakersShow"></div>
        </div>
        <div class="times-wrapper">
            <div class="btn" @click="baoEvent"></div>
            <div class="times">
                剩余行动点<strong>{{ userinfo.touzi ? userinfo.touzi : 0 }}</strong>
                <div class="add" @click="getTimesPop"></div>
            </div>
        </div>
        <!-- 活动规则 -->
        <div id="rulePop" v-show="ruleshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('ruleshow')"></span>
                <div class="time">
                    <div class="row">
                        <p>1月13日-1月20日（持续8天）</p>
                    </div>
                </div>
                <div class="note">
                    <div class="row row1">
                        <span>1、</span>
                        <p>
                            血裔们通过消耗行动点，投掷骰子在地图中前行，
                            根据不同颜色的停留格获取对应的道具奖励，联动结束前可随时领取至游戏角色邮箱。<br/>其中，抵达问号格将邂逅游戏伙伴，触发趣味事件。更有机会获得实物周边礼品！
                        </p>
                    </div>
                    <div class="row row1">
                        <span>2、</span>
                        <p>
                            旅途中集结指定伙伴，还可以在【背包】中解锁额外的伙伴赠礼。
                        </p>
                    </div>
                    <div class="row row1">
                        <span>3、</span>
                        <p>
                            血裔们每完成一圈寻宝将获得1个奇遇福袋，有概率开出大量金币、七彩盾菇、法塔能量、命运钱币、水晶、召唤卷轴等道具。
                        </p>
                    </div>
                    <div class="row">
                        <p class="red">
                            ※ 奇遇福袋领取时间：1月21日10:00-2月3日23:59。
                        </p>
                    </div>
                </div>
                <div class="how">
                    <div class="row row1">
                        <span>1、</span>
                        <p>血裔们每日登录活动页面将获得5个行动点。</p>
                    </div>
                    <div class="row row1">
                        <span>2、</span>
                        <p>使用手机号首次登录，可额外获得10个行动点。</p>
                    </div>
                    <div class="row row1">
                        <span>3、</span>
                        <p>分享活动页邀请好友助力、或关注《血族》官方微信及微博推文收集魔法密钥，可以获取更多行动点哦！</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 行动点弹窗 -->
        <div id="timesPop" v-show="timesshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('timesshow')"></span>
                <div class="attend-wrapper">
                    <div class="help-wrapper">
                        当前助力<strong>{{ userinfo.help }}</strong>人
                        <div class="view" @click="getHelpers"></div>
                    </div>
                    <div class="bar-wrapper">
                        <div class="bar">
                            <i :style='`width:${width}`'></i>
                        </div>
                        <ul>
                            <li :class='userinfo.help >= 1 ? "active" : ""'>
                                <h2>1<span>人</span></h2>
                                <div class="box box1"></div>
                                <div v-if="userinfo.help >= 1 && !userinfo.gethelplogs.includes(1)" class="get"
                                    @click="getHelpReward(1)">领取</div>
                                <div v-else-if="userinfo.help >= 1 && userinfo.gethelplogs.includes(1)" class="done">已领取
                                </div>
                                <div class="btn" v-else>未达成</div>
                            </li>
                            <li :class='userinfo.help >= 3 ? "active" : ""'>
                                <h2>3<span>人</span></h2>
                                <div class="box box2"></div>
                                <div v-if="userinfo.help >= 3 && !userinfo.gethelplogs.includes(3)" class="get"
                                    @click="getHelpReward(3)">领取</div>
                                <div v-else-if="userinfo.help >= 3 && userinfo.gethelplogs.includes(3)" class="done">已领取
                                </div>
                                <div class="btn" v-else>未达成</div>
                            </li>
                            <li :class='userinfo.help >= 6 ? "active" : ""'>
                                <h2>6<span>人</span></h2>
                                <div class="box box3"></div>
                                <div v-if="userinfo.help >= 6 && !userinfo.gethelplogs.includes(6)" class="get"
                                    @click="getHelpReward(6)">领取</div>
                                <div v-else-if="userinfo.help >= 6 && userinfo.gethelplogs.includes(6)" class="done">已领取
                                </div>
                                <div class="btn" v-else>未达成</div>
                            </li>
                            <li :class='userinfo.help >= 10 ? "active" : ""'>
                                <h2>10<span>人</span></h2>
                                <div class="box box4"></div>
                                <div v-if="userinfo.help >= 10 && !userinfo.gethelplogs.includes(10)" class="get"
                                    @click="getHelpReward(10)">领取</div>
                                <div v-else-if="userinfo.help >= 10 && userinfo.gethelplogs.includes(10)" class="done">
                                    已领取
                                </div>
                                <div class="btn" v-else>未达成</div>
                            </li>
                        </ul>
                    </div>
                    <div class="btn-share" @click="getShare"></div>
                </div>
                <div class="exchange-wrapper">
                    <input type="text" v-model.trim="mycode" />
                    <div class="btn-exchange" @click="exchangePointers"></div>
                </div>
            </div>
        </div>
        <!-- 行动点获取成功 -->
        <div id="getTimesPop" v-show="gettimesshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('gettimesshow')"></span>
                <h1>恭喜获得！</h1>
                <h3>行动点×<strong ref="getpointers"></strong></h3>
                <div class="tips">已自动计入行动点中</div>
            </div>
        </div>
        <!-- 图片分享 -->
        <div id="sharePop" v-show="shareshow" class="pop">
            <div class="content">
                <div class="img-wrapper">
                    <span class="close" @click="closePop('shareshow')"></span>
                    <img :src="myshare" alt="">
                </div>
            </div>
        </div>
        <!-- 助力记录 -->
        <div id="helpPop" class="pop" v-show="helpshow">
            <div class="content">
                <span class="close" @click="closePop('helpshow')"></span>
                <ul v-if="helpers.length">
                    <li v-for="(item, index) in helpers" :key="item.phone">
                        <strong>{{ index + 1 }}</strong>
                        <h2>{{ item.phone }}</h2>
                        <span>{{ item.date }}</span>
                    </li>
                </ul>
                <div v-else class="blank">暂时没有任何助力记录</div>
            </div>
        </div>
        <!-- 更多记录 -->
        <div id="moreSpeaker" class="pop" v-show="moreshow">
            <div class="content">
                <span class="close" @click="closePop('moreshow')"></span>
                <div class="btn-myself" @click="myselfEvent"></div>
                <ul class="speakers" v-if="speakers.logs.length">
                    <li v-for="item in speakers.logs" :key="item.phone">
                        恭喜{{ item.phone }}获得【{{ item | rewardNameFilter }}*{{ item.itemcount }}】
                    </li>
                </ul>
                <div v-else class="no-logs">
                    暂时没有任何动态消息
                </div>
                <div class="my-gift">
                    <div class="gift-wrapper">
                        <ul v-if="speakers.self.length">
                            <li v-for="item in speakers.self" :key="item.id">
                                <div class="img-wrapper">
                                    <img :src='item | rewardIconFilter' alt="">
                                </div>
                                <h4>{{ item | rewardNameFilter }}×{{ item.itemcount }}</h4>
                                <p>{{ item.date }}</p>
                            </li>
                        </ul>
                        <div class="blank-wrapper" v-else>
                            <div v-if="!userinfo.phone" class="no-login">
                                您还未登录，<span class="login" @click="loginEvent">登录</span> 即可查看我的欧皇时刻！
                            </div>
                            <div v-else class="blank">
                                您暂时没有任何奖励
                            </div>
                        </div>
                    </div>
                    <span v-if="speakers.self.length>=3" class="arrow"></span>
                </div>
            </div>
        </div>
        <!-- 获奖弹窗A -->
        <div id="rewardPop1" class="pop" v-show="reward1show">
            <div class="content">
                <span class="close" @click="closePop('reward1show')"></span>
                <h1>恭喜获得！</h1>
                <div class="img-wrapper" v-if="reward.itemid">
                    <img :src='reward | rewardIconFilter' alt="">
                </div>
                <h3 v-if="reward.itemid">{{ reward | rewardNameFilter }} × {{ reward.itemcount }}</h3>
                <div class="tips">请在【<span></span>背包】查看奖励</div>
            </div>
        </div>
        <!-- 获奖弹窗B -->
        <div id="rewardPop2" class="pop" v-show="reward2show">
            <div class="content">
                <span class="close" @click="closePop('reward2show')"></span>
                <img v-if="reward.color === 4" class="role" :src='reward | rewardRoleImg' alt="">
                <div v-if="reward.color === 4" class="note-wrapper">
                    <h1>偶遇<strong>{{ reward | rewardRoleName }}</strong></h1>
                    <p>{{ reward | rewardRoleDesc }}</p>
                    <div class="icon-wrapper">
                        <img :src='reward | rewardIconFilter' alt="" />
                    </div>
                    <h3>{{ reward | rewardNameFilter }}×{{ reward.itemcount }}</h3>
                </div>
                <div class="tips">请在【<span></span>背包】查看奖励</div>
            </div>
        </div>
        <!-- 获奖弹窗C -->
        <div id="rewardPop3" class="pop" v-show="reward3show">
            <div class="content">
                <span class="close" @click="closePop('reward3show')"></span>
                <h1>成功寻宝一圈，恭喜获得！</h1>
                <h3>奇遇福袋×1</h3>
                <div class="tips">福袋将于联动上线后开放领取</div>
            </div>
        </div>
        <!-- 领奖确认 -->
        <div id="getRewardConfirmPop" v-show="rewardsconfirmshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('rewardsconfirmshow')"></span>
                <h1>
                    您还有<strong>{{ 3 - bindlist.list.length }}</strong>次绑定游戏角色的机会，<br />
                    奖励一经领取将无法新增角色绑定，<br />
                    是否仍要领取奖励？
                </h1>
                <ul class="btns-wrapper">
                    <li @click="closePop('rewardsconfirmshow')"></li>
                    <li @click="rewardAccept"></li>
                </ul>
                <div class="btn-bind" @click="goBind"></div>
            </div>
        </div>
        <!-- 领取成功 -->
        <div id="getRewardsSuccessPop" v-show="rewardssuccessshow" class="pop">
            <div class="content">
                <span class="close" @click="closePop('rewardssuccessshow')"></span>
                <h1>奖励领取成功</h1>
                <p>请至游戏角色邮箱中查看~</p>
            </div>
        </div>
        <!-- 走棋盘 -->
        <Panel :current="current" ref="panel" />
        <!-- 掷骰子 -->
        <Dice ref="dice" />
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { GetSpeakers, GetPointer, GetHelpers, GetHelpReward, ExChangePointer, GetBagReward } from '../../../api'
import { GetShareImage } from '../../../utils'
import mixins from '../../../mixins'
import Dice from '../../../components/dice'
import Panel from '../../../components/panel'
import Speaks from '../../../components/speaks'
export default {
    name: 'Scene',
    mixins: [mixins],
    components: { Dice, Panel, Speaks },
    computed: {
        ...mapState(['userinfo', 'bindlist']),
        current() {
            let res =0;
            if (this.userinfo.step>0) {
                res = this.userinfo.step % 25 > 0 ? this.userinfo.step % 25 : 1;
            } else {
                res = 0;
            }
            return res;
        },
        width() {
            let width = 0;
            if (this.userinfo.help >= 10) {
                width = 100;
            }
            switch (this.userinfo.help) {
                case 1:
                    width = 15;
                    break;
                case 2:
                    width = 25;
                    break;
                case 3:
                    width = 40;
                    break;
                case 4:
                    width = 45;
                    break;
                case 5:
                    width = 55;
                    break;
                case 6:
                    width = 65;
                    break;
                case 7:
                    width = 70;
                    break;
                case 8:
                    width = 75;
                    break;
                case 9:
                    width = 80;
                    break;
            }
            return width + "%";
        },
        currentbag(){
            let res = 0;
            if(this.userinfo.getbag>0){
                res=this.userinfo.getbag;
            }else{
                res=Math.floor(this.userinfo.step/25);
            }
            return res;
        },
        classname(){
            let name = "";
            if(this.userinfo.getbag>0){
                name="btn done";
            }else if(this.userinfo.getbag==-1){
                name="btn disabled"
            }else{
                if(this.currentbag>0){
                    name="btn";
                }else{
                    name="btn disabled"
                }
            }
            return name;
        }
    },
    data() {
        return {
            ruleshow: false,// 活动规则弹窗
            shareshow: false,// 分享图片弹窗
            timesshow: false,// 活动点弹窗
            gettimesshow: false,// 活动点获得弹窗
            helpshow: false,// 
            moreshow: false, // 更多动态弹窗
            reward1show: false, // 蓝色紫色格子弹窗
            reward2show: false,  // 问号格子弹窗
            reward3show: false,  // 走完一圈自动弹窗
            speakers: {
                logs: [],
                self: []
            },
            louders: [],
            reward: {},
            helpers: [],
            mycode: '',
            myshare: '',
            mygetbag: 0,
            rewardsconfirmshow: false, // 奖励领取确认
            rewardssuccessshow: false,  // 奖励领取成功
            isplaying: false // 音乐播放
        }
    },
    methods: {
        ...mapMutations({ setloading: 'SETLOADING', loginShow: 'LOGINSHOW', bindsShow: 'BINDSSHOW' }),
        goBind(){
            this.rewardsconfirmshow=false;
            this.bindsShow();
        },
        async getShare() {
            this.setloading(true);
            CsLib.buttonCounts("生成分享图片")
            const res = await GetShareImage(this.userinfo.invitecode);
            if (res) {
                const img = new Image();
                img.src = res;
                img.crossOrigin = "*";
                img.addEventListener('load', () => {
                    this.setloading(false);
                    this.shareshow = true;
                    this.myshare = res;
                })
            }
        },
        async getHelpers() {
            const res = await GetHelpers();
            if (res) {
                this.helpers = res;
                this.helpshow = true;
            }
        },
        async speakersShow() {
            const res = await GetSpeakers();
            if (res) {
                this.moreshow = true;
                this.speakers ={logs:res.logs.slice(0,11),self:res.self,islogin:res.islogin};
            }
        },
        async getHelpReward(type) {
            const res = await GetHelpReward(type);
            if (res) {
                this.gettimesshow = true;
                this.$refs.getpointers.innerHTML = type*1;
                this.userinfo.gethelplogs.push(type);
                this.userinfo.touzi = this.userinfo.touzi*1 + type*1;
            }
        },
        async exchangePointers() {
            if (!this.mycode) {
                return CsLib.alert('魔法密钥不能为空', 'error');
            }
            CsLib.buttonCounts("魔法秘钥兑换")
            const res = await ExChangePointer(this.mycode);
            if (res) {
                this.gettimesshow = true;
                this.$refs.getpointers.innerHTML = 5;
                this.userinfo.touzi = this.userinfo.touzi*1 + 5;
            }
        },
        myselfEvent(){
            this.moreshow=false;
            this.timesshow=true;
            CsLib.buttonCounts('我要变欧皇')
        },
        goMyBag() {
            if (!this.userinfo.phone) {
                return this.loginShow();
            }
            this.$router.replace('/game/mybag')
        },
        getTimesPop() {
            if (!this.userinfo.phone) {
                return this.loginShow();
            }
            this.showPop('timesshow');
            CsLib.buttonCounts("查看剩余行动点")
        },
        loginEvent() {
            this.moreshow = false;
            this.loginShow();
        },
        async baoEvent() {
            // 未登录
            if (!this.userinfo.phone) {
                return this.loginShow();
            }
            // 次数不够
            if (this.userinfo.touzi === 0) {
                return CsLib.alert('您的投掷次数不足！', 'error');
            }
            if (this.$refs.panel.ing) {
                return CsLib.alert('操作太过频繁！', 'error');
            }
            const pointer = await GetPointer();
            if (pointer) {
                // 助力次数减少 
                this.userinfo.touzi--;
                const step = await this.$refs.dice.startGame(pointer.run);
                await this.$refs.panel.runPointer(step);
                this.reward = pointer;
                // 不同颜色格子奖励
                if (pointer.color === 4) {
                    this.reward2show = true;
                } else {
                    this.reward1show = true;
                }
                // 格子走一圈   宝箱出现
                if ((pointer.step % 25) + pointer.run >= 25) {
                    if(this.userinfo.getbag<=0){
                        this.reward3show = true;
                    }
                }
                this.userinfo.step = this.userinfo.step + pointer.run;
            }
        },
        async getLouders() {
            const res = await GetSpeakers();
            this.louders = res.logs;
        },
        async rewardAccept() {
            const res = await GetBagReward();
            if (res) {
                this.rewardsconfirmshow = false;
                this.rewardssuccessshow = true;
                this.userinfo.bindlock = 1;
                this.userinfo.getbag=this.currentbag;
            }
        },
        getBag() {
            if (this.currentbag === 0) {
                return false;
            }
            if(this.userinfo.getbag==-1){
                return CsLib.alert('福袋领取暂未开启','error');
            }
            // 未登录
            if (!this.userinfo.phone) {
                return this.loginShow();
            }
            // 未绑定
            if (this.bindlist.list.length === 0) {
                return this.bindsShow();
            }
            if (this.userinfo.bindlock) {
                this.rewardAccept();
            } else {
                if (this.bindlist.list.length === 3) {
                    this.rewardAccept();
                } else {
                    this.rewardsconfirmshow = true;
                }
            }
        },
        musicPlay() {
            this.$refs.bgMusic.addEventListener("playing", () => {
                this.isplaying = true;
            })
            this.$refs.bgMusic.addEventListener("pause", () => {
                this.isplaying = false;
            })
            if (window.WeixinJSBridge) {
                WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
                    this.$refs.bgMusic.play();
                }, false);
            } else {
                document.addEventListener("WeixinJSBridgeReady", function () {
                    WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
                        this.$refs.bgMusic.play();
                    });
                }, false);
            }
            this.$refs.bgMusic.play();
        },
        musicEvent() {
            if (this.isplaying === false) {
                this.$refs.bgMusic.play();
            } else {
                this.$refs.bgMusic.pause();
            }
        }
    },
    mounted() {
        this.getLouders();
        this.musicPlay();
    }
}
</script>

<style lang="scss" scoped>
@keyframes Scale {

    0%,
    100% {
        transform: scale3d(1, 1, 1);
    }

    40% {
        transform: scale3d(1.15, 0.95, 1);
    }

    70% {
        transform: scale3d(1, 1.15, 1);
    }
}

.icon {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/icon.png');
    background-size: 20rem 20rem;
    background-repeat: no-repeat;
}

.page-scene {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/2.jpg');
}

.top-btns-wrapper {
    position: absolute;
    height: 1.05rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    top: 0.76rem;
    right: 0.36rem;

    li {
        width: 1.05rem;
        height: 1.05rem;
        @extend .icon;
        position: relative;

        &:nth-of-type(1) {
            background-position: -5.03rem 0rem;
        }

        &:nth-of-type(2) {
            background-position: -6.09rem 0rem;
        }

        &:nth-of-type(3) {
            background-position: -7.15rem 0rem;

            a {
                position: absolute;
                width: 100%;
                height: 100%;
            }
        }

        &:nth-of-type(4) {
            background-position: -8.21rem 0rem;

            &.off {
                background-position: -14.50rem -4.35rem;
            }
        }
    }
}

.bag-wrapper {
    height: 0.62rem;
    position: absolute;
    top: 1.68rem;
    padding-left: 0.9rem;
    display: flex;
    align-items: center;
    transform: rotate(15deg);
    color: #fff;

    &::before {
        @extend .icon;
        position: absolute;
        content: "";
        width: 0.8rem;
        height: 1.06rem;
        background-position: -9.33rem -15.50rem;
        left: 0rem;
        top:-0.38rem;
        transform:rotate(-15deg);
    }

    strong {
        font-size: 0.36rem;
        color: #fde01a;
        margin-left: 0.04rem
    }

    .btn {
        @extend .icon;
        width: 1.40rem;
        height: 0.62rem;
        background-position: -5.68rem -1.44rem;
        transform: rotate(-15deg) translateY(-0.10rem);
        margin-left: 0.04rem;
        &.disabled {
            filter: grayscale(100);
        }
        &.done{
            background-position: -7.38rem -1.44rem;
        }
    }
}

.speaker-wrapper {
    position: absolute;
    z-index: 2;
    @extend .icon;
    background-position: -10.71rem 0rem;
    width: 6.5rem;
    height: 0.48rem;
    left: 50%;
    top: 11.25rem;
    margin-left: -3.25rem;

    .more {
        width: 0.48rem;
        height: 100%;
        position: absolute;
        right: 0rem;
        top: 0rem;
    }
}

.times-wrapper {
    position: absolute;
    z-index: 2;
    width: 4.25rem;
    left: 50%;
    top: 12rem;
    margin-left: -2.12rem;
    text-align: center;
    color: #fff;

    .btn {
        @extend .icon;
        width: 4.25rem;
        height: 1.25rem;
        background-position: -5.33rem -4.03rem;
    }

    .times {
        background-color: #2a2e4d;
        display: inline-flex;
        align-items: center;
        padding: 0.12rem 0.32rem;
        border-radius: 0.24rem;
        font-size: 0.26rem;
        margin-top: 0.16rem;

        strong {
            color: #ffe555;
            margin-left: 0.08rem;
        }

        .add {
            @extend .icon;
            width: 0.33rem;
            height: 0.33rem;
            background-position: -10.32rem 0rem;
            margin-left: 0.08rem;
        }
    }
}

#rulePop {
    animation-name: fadeInUp;

    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/rulePop.png');
        width: 100%;
        height: 15.80rem;
        left: 0rem;
        top: 0rem;
        box-sizing: border-box;
        padding: 2.5rem 0.54rem;

        .close {
            position: absolute;
            width: 0.60rem;
            height: 0.60rem;
            right: 0.32rem;
            top: 0.60rem;
            background: none;
        }

        .note {
            margin-top: 1rem;
        }

        .how {
            margin-top: 2.36rem;
        }

        .row {
            position: relative;
            color: #3e6693;

            p {
                line-height: 1.6;

                &.red {
                    color: #d44216;
                }
            }
        }

        .row1 {
            padding-left: 0.3rem;
            margin-bottom: 0.14rem;

            span {
                position: absolute;
                left: 0rem;
                top: 0.1rem;
            }
        }
    }
}

#sharePop {
    .content {
        width: 100vw;
        height: 100vh;
        overflow: scroll;
        left: 0rem;
        top: 0rem;
        display: flex;
        justify-content: center;
        align-items: center;

        .img-wrapper {
            position: relative;
            text-align: center;

            .close {
                @extend .icon;
                position: absolute;
                width: 1.11rem;
                height: 1.1rem;
                right: 0rem;
                top: -0.55rem;
                background-position: -10.72rem -1.39rem;
            }

            &::after {
                @extend .icon;
                position: absolute;
                content: "";
                width: 2.42rem;
                height: 0.28rem;
                background-position: -10.72rem -0.66rem;
                left: 50%;
                bottom: -0.46rem;
                margin-left: -1.21rem;
            }
        }

        img {
            vertical-align: top;
            width: 86%;
        }
    }
}

#timesPop {
    animation-name: fadeInUp;

    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/timesPop.png?44444');
        width: 100%;
        height: 15.54rem;
        left: 0rem;
        top: 0rem;

        .close {
            position: absolute;
            width: 0.60rem;
            height: 0.60rem;
            right: 0.32rem;
            top: 0.60rem;
            background: none;
        }

        .attend-wrapper {
            padding-top: 1.91rem;

            .help-wrapper {
                height: 0.48rem;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                padding-right: 0.74rem;
                color: #3e6693;

                strong {
                    color: #d44216;
                    margin: 0rem 0.06rem;
                }

                .view {
                    width: 1.94rem;
                    height: 0.48rem;
                    margin-left: 0.26rem;
                }
            }

            .bar-wrapper {
                width: 5.92rem;
                height: 2.3rem;
                margin: 0.72rem auto 0rem auto;
                position: relative;
                box-sizing: border-box;
                padding-top: 0.6rem;

                .bar {
                    height: 0.12rem;
                    box-sizing: border-box;
                    background: #fff;
                    border: 0.01rem solid #000;
                    position: relative;

                    i {
                        position: absolute;
                        height: 100%;
                        left: 0rem;
                        top: 0rem;
                        width: 30%;
                        background-color: #ffe21d;
                    }
                }

                ul {
                    position: absolute;
                    display: grid;
                    width: 5.92rem;
                    left: 50%;
                    top: -0.06rem;
                    margin-left: -2.96rem;
                    grid-template-columns: repeat(4, 1fr);

                    li {
                        text-align: center;
                        position: relative;

                        &:before {
                            position: absolute;
                            content: "";
                            left: 50%;
                            @extend .icon;
                            width: 0.28rem;
                            height: 0.28rem;
                            margin-left: -0.14rem;
                            top: 0.58rem;
                            background-position: -17.95rem 0rem;
                        }

                        h2 {
                            font-size: 0.44rem;
                            color: #3e6693;
                            margin-bottom: 0.6rem;

                            span {
                                font-size: 0.24rem;
                            }
                        }

                        &.active {
                            &:before {
                                background-position: -17.39rem 0rem;
                            }

                            h2 {
                                color: #e75a29;
                            }

                            .box {
                                filter: grayscale(0);
                            }
                        }

                        .box {
                            @extend .icon;
                            margin: 0rem auto;
                            filter: grayscale(100);

                            &.box1 {
                                width: 0.91rem;
                                height: 0.71rem;
                                background-position: -13.69rem -0.66rem;
                            }

                            &.box2 {
                                background-position: -14.81rem -0.66rem;
                                width: 0.94rem;
                                height: 0.71rem;
                            }

                            &.box3 {
                                background-position: -16.07rem -0.66rem;
                                width: 0.94rem;
                                height: 0.71rem;
                            }

                            &.box4 {
                                background-position: -17.33rem -0.66rem;
                                width: 1.07rem;
                                height: 0.71rem;
                            }
                        }

                        .btn {
                            width: 0.90rem;
                            height: 0.32rem;
                            line-height: 0.32rem;
                            margin: 0.24rem auto 0rem auto;
                            color: #3e6693;
                            border: 0.01rem solid #3e6693;
                        }

                        .get {
                            width: 0.90rem;
                            height: 0.32rem;
                            line-height: 0.32rem;
                            margin: 0.24rem auto 0rem auto;
                            color: #fff;
                            background-color: #e75a29;
                            border: 0.01rem solid #010101;
                        }

                        .done {
                            width: 0.90rem;
                            height: 0.32rem;
                            line-height: 0.32rem;
                            margin: 0.24rem auto 0rem auto;
                            color: #fff;
                            background-color: #504a48;
                            border: 0.01rem solid #504a48;
                        }
                    }
                }
            }

            .btn-share {
                width: 3.52rem;
                height: 0.97rem;
                margin: 0.6rem auto 0rem auto;
            }
        }

        .exchange-wrapper {
            padding-top: 3.2rem;

            input {
                width: 5.8rem;
                height: 0.8rem;
                background: none;
                border: none;
                margin: 0rem auto;
                display: block;
                outline: none;
                text-align: center;
                font-size: 0.38rem;
            }

            .btn-exchange {
                width: 3.51rem;
                height: 0.97rem;
                margin: 0.28rem auto 0rem auto;
            }
        }
    }
}

#helpPop {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/helpPop.png');
        width: 7.02rem;
        height: 5.88rem;
        margin-left: -3.51rem;
        margin-top: -2.94rem;
        padding-top: 1.7rem;
        box-sizing: border-box;

        ul {
            width: 5.30rem;
            height: 3.4rem;
            overflow: scroll;
            margin: 0rem auto;

            li {
                display: flex;
                align-items: center;
                height: 0.53rem;

                strong {
                    width: 0.36rem;
                    height: 0.33rem;
                    text-align: center;
                    line-height: 0.28rem;
                    @extend .icon;
                    color: #fff;
                    font-weight: normal;
                    font-size: 0.20rem;
                    margin-right: 0.08rem;
                    background-position: -18.66rem 0rem;
                }

                h2 {
                    font-weight: bold;
                    font-size: 0.24rem;
                    margin-right: auto;
                }

                span {
                    color: #151515;
                    font-size: 0.24rem;
                }
            }
        }

        .blank {
            text-align: center;
            line-height: 10;
        }
    }
}

#moreSpeaker {
    animation-name: fadeInUp;
    font-size: 0.22rem;
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/moreSpeaker.png');
        width: 5.97rem;
        height: 10.69rem;
        background-size: cover;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -2.98rem;
        margin-top: -5.35rem;
        box-sizing: border-box;
        padding-top: 1.6rem;

        .close {
            width: 0.50rem;
            height: 0.48rem;
            @extend .icon;
            background-position: -19.30rem 0rem;
            right: -0.52rem;
            top: 0.2rem;
        }

        .btn-myself {
            width: 2.87rem;
            height: 1.24rem;
            position: absolute;
            right: 0.2rem;
            top: 0rem;
        }

        .no-logs {
            height: 7rem;
            margin: 0rem auto;
            text-align: center;
            line-height: 3;
        }

        .speakers {
            width: 5.4rem;
            height: 7rem;
            margin: 0rem auto;
            overflow: scroll;
            color: #246eb2;
            line-height: 1.4;

            li {
                height: 0.54rem;
                position: relative;
                display: flex;
                align-items: center;
                margin-bottom: 0.06rem;

                &::before {
                    content: "·";
                    font-size: 0.5rem;
                    position: relative;
                    margin-right: 0.06rem;
                }
            }
        }

        .my-gift {
            height: 1.64rem;
            margin-top: 0.04rem;
            padding-left: 0.74rem;
            padding-right: 0.36rem;
            position: relative;
            .arrow{
                    position: absolute;
                    width: 0.16rem;
                    height: 0.24rem;
                    @extend .icon;
                    background-position:-16.19rem -3.37rem;
                    right: 0.06rem;
                    top: 50%;
                    margin-top: -0.12rem;
                }
            .gift-wrapper{
                width: 4.8rem;
                overflow: scroll;
                position: relative;
            }
            ul {
                padding: 0.2rem 0rem;
                display: flex;
                flex-wrap: nowrap;
            }

            li {
                text-align: center;
                .img-wrapper {
                    width: 0.78rem;
                    height: 0.78rem;
                    border-radius: 50%;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #f4e43c;
                    margin: 0rem auto;

                    img {
                        width: 0.68rem;
                        height: 0.68rem;
                    }
                }

                h4 {
                    font-size: 0.22rem;
                    margin: 0.08rem auto;
                    width: 2rem;
                }

                p {
                    color: #7b8890;
                }
            }

            .blank-wrapper {
                height: 1.64rem;
                line-height: 1.64rem;
                text-align: center;

                .login {
                    color: #246eb2;
                }

                .blank {
                    color: #246eb2;
                }
            }
        }
    }
}

#getTimesPop {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/getTimesPop.png');
        width: 7.02rem;
        height: 4.72rem;
        margin-left: -3.51rem;
        margin-top: -2.36rem;
        text-align: center;
        box-sizing: border-box;
        padding-top: 0.9rem;

        h1 {
            color: #151515;
            font-size: 0.36rem;
        }

        h3 {
            margin-top: 2.4rem;
        }
    }
}

#rewardPop1 {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/rewardsPopA.png');
        width: 7.02rem;
        height: 4.72rem;
        margin-left: -3.51rem;
        margin-top: -2.36rem;
        text-align: center;
        box-sizing: border-box;
        padding-top: 0.9rem;

        .img-wrapper {
            position: absolute;
            width: 1.6rem;
            height: 1.6rem;
            left: 50%;
            top: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: -0.74rem;
            margin-top: -0.7rem;

            img {
                width: 1.5rem;
            }
        }

        h1 {
            color: #151515;
            font-size: 0.36rem;
            padding-left: 0.42rem;
        }

        h3 {
            margin-top: 2.4rem;
        }

        .tips {
            span {
                width: 0.3rem;
                height: 0.3rem;
                @extend .icon;
                margin: 0rem 0.04rem;
                background-position: -17.39rem -3.36rem;
            }
        }
    }
}

#rewardPop2 {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/rewardsPopB.png');
        width: 7.02rem;
        height: 5.32rem;
        margin-left: -3.51rem;
        margin-top: -2.66rem;

        .tips {
            span {
                width: 0.3rem;
                height: 0.3rem;
                @extend .icon;
                margin: 0rem 0.04rem;
                background-position: -17.39rem -3.36rem;
            }
        }

        .role {
            position: absolute;
            width: 2.97rem;
            height: 5.70rem;
            left: 0.12rem;
            bottom: 0.2rem;
        }

        .note-wrapper {
            position: absolute;
            width: 3.70rem;
            right: 0.4rem;
            top: 0.2rem;
            text-align: center;
            padding-top: 0.7rem;

            h1 {
                color: #151515;
                font-size: 0.38rem;
                margin-bottom: 0.14rem;

                strong {
                    color: #de381d;
                }
            }

            p {
                line-height: 1.4;
                min-height: 0.8rem;
                padding-left: 0.2rem;
            }

            .icon-wrapper {
                width: 1.7rem;
                height: 1.9rem;
                display: flex;
                margin: 0rem auto;
                justify-content: center;
                align-items: center;

                img {
                    width: 1.6rem;
                }
            }

            h3 {
                margin-top: 0.12rem;
            }
        }
    }
}

#rewardPop3 {
    .content {
        background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/rewardsPopC.png');
        width: 7.02rem;
        height: 4.72rem;
        margin-left: -3.51rem;
        margin-top: -2.36rem;
        text-align: center;
        color: #151515;

        h1 {
            font-size: 0.38rem;
            padding-top: 0.9rem;
            margin-bottom: 2.36rem;
            padding-left: 0.42rem;
        }

        h3 {
            font-size: 0.26rem;
        }
    }
}
</style>